export default window.__litium.constants;

export const ViewMode = {
    List: 'list',
    Edit: 'edit',
    Detail: 'detail',
};

export const ShippingIntegrationType = {
    Inline: 'Inline',
    DeliveryCheckout: 'DeliveryCheckout',
    PaymentCheckout: 'PaymentCheckout',
};

export const PaymentIntegrationType = {
    IframeCheckout: 'IframeCheckout',
    PaymentWidgets: 'PaymentWidgets',
    DirectPayment: 'DirectPayment',
};

export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';
export const CART_RECEIVE = 'CART_RECEIVE';
export const CART_SHOW_MINI_CART = 'CART_SHOW_MINI_CART';

export const CHECKOUT_SET_EDITING_CUSTOMER_DETAILS = 'CHECKOUT_SET_EDITING_CUSTOMER_DETAILS';
export const CHECKOUT_SET_DELIVERY = 'CHECKOUT_SET_DELIVERY';
export const CHECKOUT_SET_COUNTRY = 'CHECKOUT_SET_COUNTRY';
export const CHECKOUT_SET_PAYMENT = 'CHECKOUT_SET_PAYMENT';
export const CHECKOUT_SET_DISCOUNT_CODE = 'CHECKOUT_SET_DISCOUNT_CODE';
export const CHECKOUT_SET_PURCHASE_ORDER_NUMBER = 'CHECKOUT_SET_PURCHASE_ORDER_NUMBER';
export const CHECKOUT_SET_USED_DISCOUNT_CODE = 'CHECKOUT_SET_UASED_DISCOUNT_CODE';
export const CHECKOUT_ACCEPT_TERMS = 'CHECKOUT_ACCEPT_TERMS';
export const CHECKOUT_SUBMIT = 'CHECKOUT_SUBMIT';
export const CHECKOUT_SUBMIT_ERROR = 'CHECKOUT_SUBMIT_ERROR';
export const CHECKOUT_SET_PAYMENT_WIDGET = 'CHECKOUT_SET_PAYMENT_WIDGET';
export const CHECKOUT_UPDATE_CUSTOMER_INFO = 'CHECKOUT_UPDATE_CUSTOMER_INFO';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const CHECKOUT_SET_SHIPPING_OPTION = 'CHECKOUT_SET_SHIPPING_OPTION';

export const FLASH_MESSAGE_REMOVE = 'FLASH_MESSAGE_REMOVE';
export const FLASH_MESSAGE_ADD = 'FLASH_MESSAGE_ADD';
export const FLASH_MESSAGES_LOADED = 'FLASH_MESSAGES_LOADED';

export const USER_OWNED_FULL_LICENSE_PRODUCTS_RECEIVE = 'USER_OWNED_FULL_LICENSE_PRODUCTS_RECEIVE';
export const USER_DEMOED_LICENSE_PRODUCTS_RECEIVE = 'USER_DEMOED_LICENSE_PRODUCTS_RECEIVE';

export const FLOW_CREDITS_PURCHASE_MODAL_RECEIVE = 'FLOW_CREDITS_PURCHASE_MODAL_RECEIVE';
export const FLOW_CREDITS_UPGRADE_PURCHASE_MODAL_RECEIVE = 'FLOW_CREDITS_UPGRADE_PURCHASE_MODAL_RECEIVE';

export const CUSTOMER_TYPE_PRIVATE = 'private';
export const CUSTOMER_TYPE_COMPANY = 'company';

export const MY_ACCOUNT_USER_INFO_SUBMIT_ERROR = 'MY_ACCOUNT_USER_INFO_SUBMIT_ERROR';
export const MY_ACCOUNT_USER_INFO_CLEAR_ERROR  = 'MY_ACCOUNT_USER_INFO_CLEAR_ERROR';
export const MY_ACCOUNT_USER_INFO_RECEIVE = 'MY_ACCOUNT_USER_INFO_RECEIVE';
export const MY_ACCOUNT_USER_INFO_LOAD_ERROR = 'MY_ACCOUNT_USER_INFO_LOAD_ERROR';

export const MY_ACCOUNT_EMAIL_CHANGE_ERROR = 'MY_ACCOUNT_EMAIL_CHANGE_ERROR';
export const MY_ACCOUNT_EMAIL_CLEAR_ERROR = 'MY_ACCOUNT_EMAIL_CLEAR_ERROR';
export const MY_ACCOUNT_EMAIL_LOAD_ERROR = 'MY_ACCOUNT_EMAIL_LOAD_ERROR'; 
export const MY_ACCOUNT_EMAIL_CHANGE_RECEIVE  = 'MY_ACCOUNT_EMAIL_CHANGE_RECEIVE';

export const MY_ACCOUNT_PASSWORD_CHANGE_ERROR = 'MY_ACCOUNT_PASSWORD_CHANGE_ERROR';
export const MY_ACCOUNT_PASSWORD_CLEAR_ERROR = 'MY_ACCOUNT_PASSWORD_CLEAR_ERROR';
export const MY_ACCOUNT_PASSWORD_CHANGE_RECEIVE = 'MY_ACCOUNT_PASSWORD_CHANGE_RECEIVE';

export const GENERAL_ERROR_ADD = 'GENERAL_ERROR_ADD';
export const GENERAL_ERROR_REMOVE = 'GENERAL_ERROR_REMOVE';

export const REGISTER_LICENSE_CODE_ERROR = 'REGISTER_LICENSE_CODE_ERROR';
export const REGISTER_LICENSE_CODE_CLEAR_ERROR = 'REGISTER_LICENSE_CODE_CLEAR_ERROR';
export const REGISTER_LICENSE_CODE_VALIDATE_SUCCESS = 'REGISTER_LICENSE_CODE_VALIDATE_SUCCESS';
export const REGISTER_LICENSE_CODE_RESET = 'REGISTER_LICENSE_CODE_RESET';

export const MY_SUBSCRIPTIONS_RECEIVE = 'MY_SUBSCRIPTIONS_RECEIVE';